import React from "react";
import PageWrapper from "app/components/page-wrapper/PageWrapper";
import "../../components/card/card.css";
import ImageLogo from "../../../images/boldlogo.png";
import "./pay.css";
import DropDown from "app/components/dropdown/DropDown";
import SwitchButton from "app/components/switchbutton/SwitchButton";

function Pay() {
  return (
    <>
      <div>
        <PageWrapper title="Pay">
          <div className="transaction-panel row align-items-center justify-content-center">
            <div className="col-md-10 col-10">
              <div className="d-flex logo-area mb-4">
                <div className="circle-box">
                  <img
                    src={ImageLogo}
                    alt="payulogo"
                    width="50"
                    className="pr-2"
                  />
                </div>
                <div className="brand">
                  <p>My_office</p>
                  <h2>TATA Sky</h2>
                </div>
              </div>
              <div className="card pay-card">
                <h3 className="d-flex justify-content-between align-items-center">
                  <span>Bill Details </span>
                  <DropDown />
                </h3>
                <div className="first-row">
                  <div>
                    <p>Consumer Name:</p>
                    <h3>Ashutosh Kumar</h3>
                  </div>

                  <div>
                    <p>Consumer ID:</p>
                    <h3>Tata25014032</h3>
                  </div>

                  <div>
                    <p>Number of Installment</p>
                    <h3>1</h3>
                  </div>

                  <div>
                    <p>Short Name</p>
                    <h3>My_Lic</h3>
                  </div>
                </div>

                <div className="first-row">
                  <div>
                    <p>Bill Date:</p>
                    <h3>02/05/21</h3>
                  </div>

                  <div>
                    <p>Due Date</p>
                    <h3>02/05/21</h3>
                  </div>
                </div>

                <div className="first-row bill-amount">
                  <div>
                    <p>Bill amount</p>
                    <h3>₹ 820</h3>
                  </div>
                </div>
              </div>
              <div className="mt-2 mb-2 d-flex justify-content-between">
                <div>
                  <SwitchButton label="Auto pay"></SwitchButton>
                </div>
                <div>
                  <SwitchButton label="Set Reminder"></SwitchButton>
                </div>
              </div>

              <div className="d-flex bottom-buttons">
                <button className="btn font_600 button btn-primary mr-4 col-md-3">
                  Pay
                </button>
                <button className="btn font_600 button btn-primary-outline col-md-3">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </PageWrapper>
      </div>
    </>
  );
}

export default Pay;
